'use client';

import { useState } from 'react';
import { Phone, Mail, MapPin, Clock, Send } from 'lucide-react';
import api from '@/lib/axios';

export default function IletisimPage() {
  const [form, setForm] = useState({ ad: '', email: '', konu: '', mesaj: '' });
  const [gonderildi, setGonderildi] = useState(false);

  const [gonderiyor, setGonderiyor] = useState(false);
  const [hata, setHata] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setGonderiyor(true);
    setHata('');
    try {
      await api.post('/iletisim', form);
      setGonderildi(true);
    } catch {
      setHata('Mesaj gönderilemedi. Lütfen tekrar deneyin.');
    }
    setGonderiyor(false);
  };

  return (
    <div className="min-h-screen bg-[var(--color-gray-50)]">

      {/* Hero */}
      <div className="bg-gradient-to-br from-[var(--color-primary)] to-[var(--color-primary-dark)] text-white">
        <div className="max-w-5xl mx-auto px-4 py-10 text-center">
          <h1 className="text-3xl md:text-4xl font-bold mb-2">İletişim</h1>
          <p className="text-base text-blue-100">Size yardımcı olmaktan memnuniyet duyarız</p>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">

          {/* Sol - İletişim Bilgileri */}
          <div className="space-y-4">

            {/* İletişim Kartları */}
            <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6 space-y-5">
              <h2 className="font-bold text-gray-800 text-lg">İletişim Bilgileri</h2>

              <a href="tel:+905324379608" className="flex items-start gap-4 group">
                <div className="w-10 h-10 bg-blue-50 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:bg-blue-100 transition">
                  <Phone size={18} className="text-[var(--color-primary)]" />
                </div>
                <div>
                  <p className="text-xs text-gray-400 mb-0.5">Telefon 1</p>
                  <p className="font-semibold text-gray-800 group-hover:text-[var(--color-primary)] transition">+90 (532) 437 96 08</p>
                </div>
              </a>

              <a href="tel:+905527046515" className="flex items-start gap-4 group">
                <div className="w-10 h-10 bg-blue-50 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:bg-blue-100 transition">
                  <Phone size={18} className="text-[var(--color-primary)]" />
                </div>
                <div>
                  <p className="text-xs text-gray-400 mb-0.5">Telefon 2</p>
                  <p className="font-semibold text-gray-800 group-hover:text-[var(--color-primary)] transition">+90 (552) 704 65 15</p>
                </div>
              </a>

              <a href="mailto:info@karacaspormarket.com" className="flex items-start gap-4 group">
                <div className="w-10 h-10 bg-blue-50 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:bg-blue-100 transition">
                  <Mail size={18} className="text-[var(--color-primary)]" />
                </div>
                <div>
                  <p className="text-xs text-gray-400 mb-0.5">E-posta</p>
                  <p className="font-semibold text-gray-800 group-hover:text-[var(--color-primary)] transition text-sm">info@karacaspormarket.com</p>
                </div>
              </a>

              <div className="flex items-start gap-4">
                <div className="w-10 h-10 bg-blue-50 rounded-xl flex items-center justify-center flex-shrink-0">
                  <MapPin size={18} className="text-[var(--color-primary)]" />
                </div>
                <div>
                  <p className="text-xs text-gray-400 mb-0.5">Adres</p>
                  <p className="font-semibold text-gray-800 text-sm">Paşaalanı Mah. 451. Sok No:27</p>
                  <p className="text-gray-500 text-sm">Karesi / Balıkesir</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-10 h-10 bg-blue-50 rounded-xl flex items-center justify-center flex-shrink-0">
                  <Clock size={18} className="text-[var(--color-primary)]" />
                </div>
                <div>
                  <p className="text-xs text-gray-400 mb-0.5">Çalışma Saatleri</p>
                  <p className="font-semibold text-gray-800 text-sm">Pzt - Cts: 09:00 - 18:00</p>
                </div>
              </div>
            </div>

            {/* Sosyal Medya */}
            <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6">
              <h2 className="font-bold text-gray-800 mb-4">Sosyal Medya</h2>
              <div className="space-y-3">
                <a
                  href="https://www.instagram.com/karacaspormarket"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 p-3 rounded-xl bg-gradient-to-r from-purple-50 to-pink-50 hover:from-purple-100 hover:to-pink-100 transition"
                >
                  <span className="text-lg">📸</span>
                  <span className="font-medium text-gray-700 text-sm">@karacaspormarket</span>
                </a>
                <a
                  href="https://www.facebook.com/karacaspormarket"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 p-3 rounded-xl bg-blue-50 hover:bg-blue-100 transition"
                >
                  <span className="text-lg">👍</span>
                  <span className="font-medium text-gray-700 text-sm">karacaspormarket</span>
                </a>
              </div>
            </div>
          </div>

          {/* Sağ - Form + Harita */}
          <div className="lg:col-span-2 space-y-6">

            {/* İletişim Formu */}
            <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6 md:p-8">
              <h2 className="font-bold text-gray-800 text-lg mb-6">Bize Yazın</h2>

              {gonderildi ? (
                <div className="text-center py-8">
                  <div className="text-4xl mb-3">✅</div>
                  <h3 className="font-bold text-gray-800 mb-2">Mesajınız İletildi!</h3>
                  <p className="text-gray-500">En kısa sürede size geri dönüş yapacağız.</p>
                  <button
                    onClick={() => { setGonderildi(false); setForm({ ad: '', email: '', konu: '', mesaj: '' }); }}
                    className="mt-4 text-[var(--color-primary)] text-sm hover:underline"
                  >
                    Yeni mesaj gönder
                  </button>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="space-y-4">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-600 mb-1.5">Ad Soyad *</label>
                      <input
                        type="text"
                        required
                        value={form.ad}
                        onChange={(e) => setForm(p => ({ ...p, ad: e.target.value }))}
                        placeholder="Adınız Soyadınız"
                        className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[var(--color-primary)] focus:border-transparent"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-600 mb-1.5">E-posta *</label>
                      <input
                        type="email"
                        required
                        value={form.email}
                        onChange={(e) => setForm(p => ({ ...p, email: e.target.value }))}
                        placeholder="ornek@email.com"
                        className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[var(--color-primary)] focus:border-transparent"
                      />
                    </div>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-600 mb-1.5">Konu *</label>
                    <input
                      type="text"
                      required
                      value={form.konu}
                      onChange={(e) => setForm(p => ({ ...p, konu: e.target.value }))}
                      placeholder="Mesajınızın konusu"
                      className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[var(--color-primary)] focus:border-transparent"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-600 mb-1.5">Mesaj *</label>
                    <textarea
                      required
                      value={form.mesaj}
                      onChange={(e) => setForm(p => ({ ...p, mesaj: e.target.value }))}
                      rows={5}
                      placeholder="Mesajınızı buraya yazın..."
                      className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[var(--color-primary)] focus:border-transparent resize-none"
                    />
                  </div>
                  <button
                    type="submit"
                    className="w-full flex items-center justify-center gap-2 bg-[var(--color-primary)] text-white py-3 rounded-xl font-semibold hover:bg-[var(--color-primary-dark)] transition"
                  >
                    <Send size={16} />
                    Gönder
                  </button>
                </form>
              )}
            </div>

            {/* Harita */}
            <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3070.5!2d27.8784!3d39.6484!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zUGHFn2FhbGFuw4csIDQ1MS4gU29rIE5vOjI3LCBLYXJlc2kgQmFsxLFrZXNpcg!5e0!3m2!1str!2str!4v1620000000000!5m2!1str!2str"
                width="100%"
                height="300"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Karacaspor Konum"
              />
              <div className="p-4 flex items-center gap-2 text-sm text-gray-500">
                <MapPin size={14} className="text-[var(--color-primary)]" />
                <span>Paşaalanı Mah. 451. Sok No:27, Karesi / Balıkesir</span>
                <a
                  href="https://maps.google.com/?q=Paşaalanı+mah+451+sok+no:27+Karesi+Balıkesir"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="ml-auto text-[var(--color-primary)] hover:underline font-medium"
                >
                  Yol Tarifi Al →
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
